// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root___Vr3g","header":"PatientBlock_header__3R2YC","label":"PatientBlock_label__rRmd6","option":"PatientBlock_option__3tOdn"};